// extracted by mini-css-extract-plugin
export var button_container = "index-module--button_container--d8571";
export var content_left = "index-module--content_left--f5586";
export var content_right = "index-module--content_right--a75e6";
export var copyright_info = "index-module--copyright_info--c0e47";
export var footer_banner__container = "index-module--footer_banner__container--4860f";
export var footer_banner__content = "index-module--footer_banner__content--67647";
export var footer_score_star = "index-module--footer_score_star--233b6";
export var footer_star_container = "index-module--footer_star_container--a3af2";